import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

import { Employee } from '../../models/employee.model';
import { EmployeeService } from '../../services/employee.service';

@Component({
  selector: 'app-employee-detail',
  templateUrl: './employee-detail.component.html',
  styleUrls: ['./employee-detail.component.scss'],
  standalone: false,
})
export class EmployeeDetailComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly employeeService = inject(EmployeeService);

  readonly employee = toSignal(
    this.employeeService.watchEmployee(
      this.route.parent!.paramMap.pipe(
        map((params) => Number(params.get('employeeId'))),
        filter((employeeId) => !Number.isNaN(employeeId)),
        distinctUntilChanged(),
      ),
    ),
    { initialValue: undefined as Employee | undefined },
  );

  getName(employee: Employee) {
    return [employee.firstName, employee.lastName].filter(Boolean).join(' ') || employee.userName;
  }
}
